var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white"},[_c('Header'),_c('GonggeList',{attrs:{"list":_vm.listGg,"cname":"bsbottom"}}),_c('MenuList',{attrs:{"list":_vm.listOne,"cname":"bsbottom"}}),_c('MenuList',{attrs:{"list":_vm.listTwo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }